<template>
  <div>
    <Head title="Invite Business User"/>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag='Link' href="/sector-targets">Sector Targets</b-breadcrumb-item>
      <b-breadcrumb-item tag='Link' active>
        Create
      </b-breadcrumb-item>
    </b-breadcrumb>
    <card-component title="Assign User">
      Look up existing user
      <div class="my-2">
        <b-autocomplete
          :data="userList"
          placeholder="Type a User Name..."
          @typing="updateUserList"
          @select="selectUser">
          <template #default="props">
            {{ props.option.first_name }} {{props.option.last_name}}
          </template>
        </b-autocomplete>
        <div v-if="selectedUser" v-show="selectedUser">
          <p>
            {{selectedUser.first_name}} {{selectedUser.last_name}}
            <br>
            {{selectedUser.email}}
          </p>
          <b-button :disabled="!selectedUser" class="btn-indigo" @click="assignContactToUser">Assign User</b-button>
        </div>
      </div>
      or
      <div class="my-2">
        <p>
          Send a new user invite to {{fullName}}?
        </p>
        <b-button
          type="is-info"
          :disabled="contact.user"
          @click="sendInvite">
          Invite User
        </b-button>
    </div>
    </card-component>
  </div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios';
import CardComponent from "@/Shared/CardComponent";

export default {
  components: {
    CardComponent,
    LoadingButton,
  },
  props: {
    business: Object,
    contact: Object
  },
  data() {
    return {
      userList: [],
      selectedUser: null,
      isFetchingUsers: false,
    }
  },
  computed: {
    fullName(){
      return `${this.contact.first_name} ${this.contact.last_name}`
    }
  },
  methods: {
    async sendInvite() {
      await axios.post(`/businesses/${this.business.id}/invite-contact/${this.contact.id}`);
      this.$parent.close();
    },
    async assignContactToUser() {
      await axios.post(`/businesses/${this.business.id}/assign-contact/${this.contact.id}`, {user_id: this.selectedUser.id});
      this.$parent.close();
    },
    async updateUserList(query) {
      this.isFetchingUsers = true;
      let {data} = await axios.get('/users/search?role=customer&search=' + query);
      this.userList = data.users;
      this.isFetchingUsers = false
    },
    selectUser(user){
      this.selectedUser = user;
    },
  },
}
</script>
